export type OpeningSeedSource = "manual" | "pgn";

export type OpeningSeedSelection = {
  source: OpeningSeedSource;
  moves: string[];
  sanMoves: string[];
  selectedPly: number;
  finalFen: string;
  sideToMove: "white" | "black";
  label?: string | null;
  headers?: Record<string, string>;
  warnings?: string[];
};

export type OpeningSeedPreview = {
  source: OpeningSeedSource;
  moves: string[];
  san_moves: string[];
  seed_ply: number;
  final_fen: string;
  side_to_move: "white" | "black";
  label?: string | null;
  headers: Record<string, string>;
  warnings: string[];
};

export function selectionFromPreview(preview: OpeningSeedPreview): OpeningSeedSelection {
  return {
    source: preview.source,
    moves: preview.moves,
    sanMoves: preview.san_moves,
    selectedPly: preview.seed_ply,
    finalFen: preview.final_fen,
    sideToMove: preview.side_to_move,
    label: preview.label,
    headers: preview.headers,
    warnings: preview.warnings,
  };
}
